export const noChallengesEvent = document.createEvent('Event');
noChallengesEvent.initEvent('challenges-carousel:no-challenges', true, true);
